// @flow

import createAction from 'redux-actions/lib/createAction';


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type RemovePathFromRouterHistoryActionType = 'ROUTER_HISTORY:REMOVE_PATH';

export type RemovePathFromRouterHistoryActionPayload = {||};

export type RemovePathFromRouterHistoryActionMeta = {||};

export type RemovePathFromRouterHistoryAction = {
  type: RemovePathFromRouterHistoryActionType,
  payload: RemovePathFromRouterHistoryActionPayload,
  meta: RemovePathFromRouterHistoryActionMeta,
};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: RemovePathFromRouterHistoryActionType = 'ROUTER_HISTORY:REMOVE_PATH';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const removePathFromRouterHistory: () => RemovePathFromRouterHistoryAction = createAction(
  type,
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default removePathFromRouterHistory;



// WEBPACK FOOTER //
// ./src/actions/router/removePathFromRouterHistory.js